module.exports = __webpack_public_path__ + "static/media/smores-deluxe.30e7fd20.png";